var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwapArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.4353 15.6169L19.6234 28.7877C19.2469 29.164 18.6822 29.164 18.1175 28.9759C17.5528 28.7877 17.3646 28.2232 17.3646 27.6588V21.6378L1.31766 19.38C0.56471 19.38 0 18.6273 0 17.8747L0 11.2893C0 10.5367 0.56471 9.97222 1.31766 9.78406L17.3646 7.5262V1.50524C17.3646 0.940779 17.741 0.376312 18.1175 0.188158C18.3057 0.188158 18.494 3.8147e-06 18.6822 3.8147e-06C19.0587 3.8147e-06 19.2469 0.18816 19.6234 0.376314L35.4353 13.359C35.8118 13.5472 36 14.1116 36 14.4879C36 15.0524 35.8118 15.4287 35.4353 15.6169Z",
    fill: "#CECECE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapArrow);
export default __webpack_public_path__ + "static/media/swap-arrow.34e376be.svg";
export { ForwardRef as ReactComponent };